<template>
    <div id="reg">
        <form action="" class="form">
            <p>
               <input type="text" placeholder="手机号码" v-model.number.trim="reg.phone" :class="{'error-input':error.phone}" autocomplete="off">
            </p>
            <p>

                <input type="text" placeholder="验证码" v-model="reg.captcha" class="captcha" :class="{'error-input':error.captcha}" autocomplete="off">
                <span class="captcha-img"><img :src="captcha"  alt="" class="" @click="editCaptcha"></span>
            </p>
            <p class="getmess">
                <input type="mess" placeholder="短信验证码" v-model="reg.code" :class="{'error-input':error.code}" autocomplete="off">
                <span @click="getSms" >{{mess}}</span>
            </p>


        </form>
        <button class="btn" @click="doreg">立即注册</button>

    </div>
</template>

<script>
    export default {
        name: "Reg",
        data (){
            return {
                cburl : this.$route.query.cburl || '/',
                captcha : '/api/captcha.html',
                mess : '获取验证码',
                error:{
                    phone : false,
                    code : false,
                    captcha : false
                },
                reg :{
                    phone : '',
                    code : '',
                    captcha : ''
                }
            }
        },methods : {
            editCaptcha (){
                this.captcha = '/api/captcha.html?d=' + Math.random()
            },
            getSms(){
                var _this = this;

                var reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
                if(!reg.test(this.reg.phone)){
                    this.error.phone = true;
                    this.$message.error('请输入正确的手机号码！');
                    return false;
                }
                this.error.phone = false;

                if(this.reg.captcha.length != 4){
                    this.error.captcha = true;
                    this.$message.error('验证码有误！');
                    return false;
                }
                this.error.captcha = false;

                if(this.getMess){
                    return false;
                }
                this.getMess = true;

                this.axios.post("/api/login/getSmsCode",{
                    phone : this.reg.phone,
                    vercode : this.reg.captcha,
                }).then(response => {
                    let data = response.data;
                    if(data.code > 0){
                        this.$message.success(data.msg);
                        let time = 60;
                        let t = setInterval(function () {
                            time --;
                            _this.mess = time + ' 秒'
                            if(time < 1){
                                clearInterval(t);
                                _this.mess = "获取验证码"
                                _this.getMess = false;
                                _this.editCaptcha();
                                _this.reg.captcha = '';
                            }
                        },1000)

                    }else{
                        this.$message.error(data.msg);
                        this.editCaptcha();
                        this.reg.captcha = '';
                        this.getMess = false;
                    }
                })

            },
            doreg(){
                if(this.reg.code.length != 6){
                    this.error.code = true;
                    this.$message.error('手机验证码有误！');
                    return false;
                }

                this.error.code = false;

                this.axios.post('/api/login/reg',{
                    phone : this.reg.phone,
                    smscode : this.reg.code
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);
                    }else{
                        this.$message.success(data.msg);
                        //存储用户信息
                        this.$store.dispatch('setUserInfo',data.data);
                        this.$router.push(this.cburl);
                    }
                })
            }
        }
    }
</script>

<style lang="less">
    #reg{
        .captcha{width: 300px;}

        .captcha-img{position: absolute;right: 0;top:12px;height: 70px;width: 250px;z-index: 999;padding: 0 20px;border-left: 1px solid #efefef;
            img{width:100%;height:70px;}

        }
        .getmess{

            span{position: absolute;right: 0;top:12px;color:@theme;text-align:center;line-height:70px;width: 250px;height: 70px;z-index: 999;padding: 0 20px;border-left: 1px solid #efefef;}
        }
    }
</style>
